import { useState, useEffect } from 'react';
import ThreatActorHeatmap from './ThreatActorHeatmap';
import ActorTracker from './settings/ActorTracker';
import RansomwareVictims from './RansomwareVictims';
//import ThreatTrends from './ThreatTrends';

const tabs = [
  { name: 'Threat Actor Heatmap', key: 'heatmap' },
  { name: 'Track Actors', key: 'tracker' },
  { name: 'Ransomware Victims', key: 'victims' },
  {/*{ name: 'Threat Trends', key: 'threat_trends' },*/}
];

export default function InsightsPage() {
  const [activeTab, setActiveTab] = useState('heatmap');
  const [trackedActors, setTrackedActors] = useState([]);

  useEffect(() => {
    const saved = localStorage.getItem("tracked_actors");
    if (saved) {
      setTrackedActors(JSON.parse(saved));
    }
  }, []);

  return (
    <div className="p-4 max-w-6xl mx-auto pt-8 lg:pt-12">
      <div className="border-b border-gray-700 mb-6">
        <nav className="-mb-px flex space-x-8 overflow-x-auto">
          {tabs.map((tab) => (
            <button
              key={tab.key}
              onClick={() => setActiveTab(tab.key)}
              className={`pb-2 px-3 text-sm font-medium whitespace-nowrap ${
                activeTab === tab.key
                  ? 'border-b-2 border-purple-500 text-purple-300'
                  : 'text-gray-400 hover:text-gray-200'
              }`}
            >
              {tab.name}
            </button>
          ))}
        </nav>
      </div>

      <div>
        {activeTab === 'heatmap' && <ThreatActorHeatmap trackedActors={trackedActors} />}
        {activeTab === 'tracker' && <ActorTracker onChange={setTrackedActors} />}
        {activeTab === 'victims' && <RansomwareVictims />}
        {/* {activeTab === 'threat_trends' && <ThreatTrends />} */}
      </div>
    </div>
  );
}
